import React from 'react';
import '../styles/SkeletonLoader.scss';

interface SkeletonLoaderProps {
  rows?: number;
  columns?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ rows = 5, columns = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <tr key={rowIndex} className="skeleton-row">
          {Array.from({ length: columns }, (_, colIndex) => (
            <td key={colIndex} className="skeleton-cell">
              <div className="skeleton-content"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default SkeletonLoader;